module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pv5 w-100 tc bg-washed-red"
  }, [_c('input', {
    staticClass: "input-reset dn",
    attrs: {
      "id": _vm.id,
      "type": "file",
      "capture": "environment",
      "accept": _vm.uploadTypes,
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.processImage($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "dib fw5 pv2 ph5 br-pill pointer ba bw1 white bg-theme b-theme",
    attrs: {
      "for": _vm.id
    }
  }, [_c('svg', {
    staticClass: "v-sub mr1",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18",
      "viewBox": "0 0 20 18",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "white"
  }, [_vm._v(_vm._s(this.images.length === 0 ? 'Upload' : 'Choose more pictures'))])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.images.length) ? _c('div', [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: image.uploadNumber,
      staticClass: "flex w-100 bl br bb b1 pa3 justify-between bg-white b--black-20 black list-item",
      class: 0 === index ? 'bt' : ''
    }, [_c('div', {
      staticClass: "v-mid"
    }, [_vm._v("Image #" + _vm._s(image.uploadNumber) + " "), _c('span', {
      staticClass: "gray"
    }, [_vm._v("- " + _vm._s(_vm.truncateMiddle(image.file.name, 10, 8)))])]), _vm._v(" "), _c('img', {
      staticClass: "pointer",
      attrs: {
        "src": "/static/appicons/x-circle.svg",
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    })])
  }), 0)], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13714a0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13714a0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImgInput.vue
// module id = 1538
// module chunks = 0